



























import {Component, Vue} from "vue-property-decorator";

@Component({})
export default class App extends Vue {
    items = [
        {icon: "mdi-contacts", text: "Доступные действия", to: "Home"},
        {icon: "mdi-history", text: "Добавленные действия БП", to: "About"},
        {icon: "mdi-help-circle", text: "Помощь", to: "Help"}
    ];
}
